const searchList = document.querySelector('.search-result');

if (searchList) {
  const searchInput = searchList.querySelector('.search-result__input-field');

  // Set search input value on keyup
  searchInput.addEventListener('keyup', () => {
    const inputValue = searchInput.value;
    searchInput.setAttribute('value', inputValue);
  });

  // Get the URL search parameters from URL
  const params = new URLSearchParams(window.location.search);
  const inputValue = params.get('searchTerm') || params.get('headerSearchTerm') || '';

  if (inputValue || params.get('pageNumber')) {
    searchInput.setAttribute('value', inputValue);
    searchList.scrollIntoView();
  }

  // Axios get paginated post list
  const axiosGetPaginatedSearchList = async (pageNumber = '1', searchTerm = '') => {
    const formDataInput = {
      action: 'getSearchList',
      pageNumber,
      searchTerm,
    };

    try {
      const { data } = await axios.post(localData.siteURL, formDataInput);
      const searchListRow = searchList.querySelector('.search-result__list');
      const searchCount = searchList.querySelector('.search-result__count');
      const searchNotFound = searchList.querySelector('.search-result__no-result-text');

      if (searchNotFound && data.data.result_text) {
        searchListRow.innerHTML = '';
        searchNotFound.classList.remove('hide');
      } else {
        searchNotFound.classList.add('hide');
      }

      if (searchCount && data.data.result_count) {
        const currentText = searchCount.textContent;
        const updatedText = currentText.replace(/(\d+)/, data.data.result_count);
        searchCount.textContent = updatedText;
      }

      if (searchListRow && data.data.html_list) {
        searchListRow.innerHTML = data.data.html_list;
      }

      const searchListFooter = searchList.querySelector('.search-result__footer');
      if (searchListFooter && data.data.html_pagination) {
        searchListFooter.innerHTML = data.data.html_pagination;
        searchList.scrollIntoView();
      }

      const [baseUrl] = window.location.href.split('?');
      const urlParams = ['searchTerm', 'pageNumber']
        .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
        .map((item) => `${item}=${formDataInput[item]}`)
        .join('&');

      window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    } catch (err) {
      console.error(err);
    }
  };

  // Search input
  const searchButtonSubmit = searchList.querySelector('.search-result__submit');
  searchButtonSubmit.addEventListener('click', (ev) => {
    ev.preventDefault();

    const inputValue = searchInput.value;

    if (inputValue) {
      axiosGetPaginatedSearchList('1', inputValue);
    }
  });

  // Pagination
  attachEvent('.search-result .pagination .pagination__number', 'click', (e) => {
    e.preventDefault();

    const inputValue = searchInput.value;

    if (inputValue) {
      axiosGetPaginatedSearchList(
        e.target.dataset.page ?? e.target.closest('.pagination__number').dataset.page,
        searchInput.value,
      );
    }
  });
}
